//#region types
import { InputProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import BaseInput from "./baseInput";
import { FormControl } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";

function PasswordInput(props: InputProps) {
  return (
    <FormControl fullWidth className={cssExports.inputFormControl}>
      <BaseInput {...props} type="password" data-testid={`${props.name}PasswordInput`} />
    </FormControl>
  );
}

export default PasswordInput;
